import { TruckDeliveryIcon } from './TruckDeliveryIcon';

/**
 * author: Simran
 * id D0EB091D-C62C-4A93-9AE4-AE942F5738C7
 * name truck-delivery
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-delivery.svg
 * tags
 * - Transportation + Road 
 */
export const LorryDeliveryIcon = TruckDeliveryIcon;
export default LorryDeliveryIcon